import { computed } from 'vue';
import useLatchkeyStore from '~/stores/useLatchkeyStore';
import { useProduct } from '~/modules/product/composables/useProduct';
import SelectedLatchkeyParser from '../parsers/SelectedLatchkeyParser';
import { getFirstUpcIdFromSelectedLatchkey } from '../utils/utils';

/**
 * WARNING: doesn't support more then 1 latchkey product id per page. Fix if needed
 */
function useSelectedLatchkey() {
  const { productData: product } = useProduct();

  const latchkeyStore = useLatchkeyStore();

  if (!latchkeyStore.initialized) {
    latchkeyStore.initialized = true;

    const selectedLatchkey = SelectedLatchkeyParser(product) || '';
    latchkeyStore.selectedLatchkey = selectedLatchkey;

    const firstUpcIdForSelectedLatchkey = getFirstUpcIdFromSelectedLatchkey(product, selectedLatchkey) || '';
    latchkeyStore.firstUpcIdForSelectedLatchkey = firstUpcIdForSelectedLatchkey;
  }

  return computed({
    get() {
      return latchkeyStore.selectedLatchkey;
    },
    set(value) {
      const previousSelectedLatchkey = latchkeyStore.selectedLatchkey;
      const firstUpcIdForSelectedLatchkey = getFirstUpcIdFromSelectedLatchkey(product, value) || '';

      latchkeyStore.previousSelectedLatchkey = previousSelectedLatchkey;
      latchkeyStore.selectedLatchkey = value;
      latchkeyStore.firstUpcIdForSelectedLatchkey = firstUpcIdForSelectedLatchkey;
    },
  });
}

export default useSelectedLatchkey;
